import App from 'App.tsx'
import { createRoot } from 'react-dom/client'
import 'styles/global.css'

const element = document.getElementById('root') as HTMLElement
const root = createRoot(element)

root.render(<App />)
